module.exports = __webpack_public_path__ + "static/media/eleme.96c7204b7010de776f977b6d2ea7cd96.svg";